@if (office) {
  <div class="office">
    @if (office.name) {
      <div class="fst-italic">
        @if (canViewOffice) {
          <a href="/capture-admin/offices/{{ office.id }}" target="_blank">
            {{ office.name }}
          </a>
        } @else {
          {{ office.name }}
        }
        @if (allowCopyOfficeName) {
          <app-copy-to-clipboard [text]="office.name" />
        }
      </div>
    }
    @if (office.aka) {
      <div class="fst-italic">{{ office.aka }}</div>
    }
    @if (office.address1) {
      <div>{{ office.address1 }}</div>
    }
    @if (office.address2) {
      <div>{{ office.address2 }}</div>
    }
    <div>
      {{ office.city }}, {{ office.state }} {{ office.zip }}
    </div>
    @if (displayPhoneAndFax) {
      <div>
        @if (office.phone) {
          <strong>P:</strong>
        }
        <app-phone-number [number]="office.phone" [dialpad]="true" />
        @if (office.fax) {
          <strong>F:</strong>
        }
        <app-office-fax [office]="office" />
        @if (providerOffice && providerOffice.status) {
          <span
            title="{{ keyedProviderOfficeStatusOptions[providerOffice.status]?.display }}">
            ({{ providerOffice.status | providerOfficeFaxStatus }})
          </span>
        }
        @if (office.hieConsultNotesCollected) {
          <span
            class="indicator-pill indicator-pill-green"
            title="HIE Consult Notes Collected">
            HIE
          </span>
        }
      </div>
    }
  </div>
}
